import React from "react";
import styles from './styles.module.scss';
import Button from "../../components/Button";
import {useModal} from "../../components/RegModal/ModalContext";

const TYPE_MAP = {
  area: {
    name: "区域报告",
    color: "#52A0FA"
  },
  industry: {
    name: "行业研究",
    color: "#52A0FA"
  },
  month: {
    name: "月度观察",
    color: "#6387FA"
  },
  year: {
    name: "年度盘点",
    color: "#D85150"
  }
}

const list = [
  {
    tags: "2026年第一季度",
    type: "area",
    name: "安徽省及合肥市私募股权市场数据观察报告",
    title: "烯牛数据：2026年Q1安徽省及合肥市私募股权市场数据观察报告",
    desc: "2026年Q1，安徽省新增认缴出资规模145.65亿元。其中合肥一个城市，出资98.97亿元，占比68%。去年同期合肥的占比是42%，全省总盘子238亿，今年全省缩到146亿，合肥几乎没跌，反而因为其他城市的收缩进一步放大了主导地位，占比直接拉到68%。2026年Q1，安徽省新一代信息技术赛道（核心就是半导体）占全省战略性新兴产业融资事件的比例达47.10%。安徽全省存续的百亿级基金，一共10只，7只注册在合肥。"
  },
  {
    tags: "2026年4月",
    type: "month",
    name: "中国私募股权市场数据观察",
    en: "China Private Equity Market Data Watch",
    title: "烯牛数据：2026年4月中国私募股权市场数据观察报告",
    desc: "2026年4月，共有540家LP出资，累计出资了299只备案基金，累计认缴出资规模1,209.13亿元。从基金管理人和备案基金来看，新增私募基金管理人6家，注销数量创近一年以来单月新高，达206家，新增备案基金677家。投融资事件共1,030起，同比增长12.20%，披露投融资金额604.14亿元，同比增长151.27%。"
  },
  {
    tags: "2026年第一季度",
    type: "year",
    name: "科创金融数据观察",
    en: "FINANCE DATA WATCH ON TECH INNOVATION",
    title: "烯牛数据：2026年Q1科创金融数据观察报告",
    desc: "2026年第一季度共有1,943家LP出资，累计出资了1,340只备案基金，累计认缴出资规模4,122.54亿元。与2025年第一季度相比，活跃LP数量和出资的基金数量均有所增长，但出资规模同比下降了36.98%。2026年第一季度投融资事件共3,078起，同比增长30.36%，披露投融资金额1,747.71亿元，同比增长101.50%。从细分赛道来看，具身智能赛道成资本主战场，融资事件数、金额断层第一，创新药赛道排名第二。从平均融资金额来看，量子科技平均融资额达2025年全年均值的两倍。"
  },
  {
    tags: "2025年年度",
    type: "year",
    name: "中国私募股权市场报告",
    en: "China Private Equity Market Report, 2025",
    title: "烯牛数据：2025年中国私募股权市场报告",
    desc: "2025年，国内私募股权市场历经四年调整期后迎来结构性复苏，全国LP出资规模21,913.83亿元，时隔四年首现正增长；国资类LP认缴规模突破2万亿元，占比超90%；投融资事件12,627起，融资金额6,756.73亿元，同比分别增长3.36%和3.62%；人工智能融资733.99亿元，为唯一连续三年增长行业；具身智能融资爆发，规模从66.57亿元飙升至473.71亿元，增幅超6倍；IPO数量触底回升，港股上市企业激增近170%，VC/PE支持IPO渗透率维持70%以上高位；机构退出回报亮眼，摩尔线程创5385倍投资回报纪录。"
  },
  {
    tags: "2025年上半年",
    type: "year",
    name: "中国私募股权市场报告",
    en: "China Private Equity Market Report, H1 2025",
    title: "烯牛数据：2025年上半年中国私募股权市场报告",
    desc: "2025年上半年，国内募资市场时隔四年首次正增长，备案基金数与认缴规模双增长，国资和政府引导基金背景的LP数量、认缴金额占比提升至59%和85%，AIC成私募股权新活水。创投市场融资事件数共4,752起，同比减少16%，融资金额1,847亿元，同比减少38%，具身智能、细胞与基因治疗等赛道逆势增长。IPO数量触底回升，A股、港股IPO共94起，同比增长27%，45支基金退出回报率超20倍。"
  },
  {
    tags: "2025年第一季度",
    type: "area",
    name: "深圳科创市场报告",
    en: "Shenzhen Science and Innovation Market Report",
    title: "烯牛数据：2025年一季度深圳创投市场报告",
    desc: "2024年至2025年第一季度，深圳已成为全国创投市场“第三城”，并逐步缩小与北京、上海的差距。深圳融资事件数量波动率低于全国，2025年部分融资阶段事件数量实现正向增长。先进制造、医疗、企业服务、人工智能与新能源为五大重点融资领域，AIGC赛道逆袭登顶为最热门赛道。"
  },
  {
    tags: "2025年第一季度",
    type: "area",
    name: "浙江省科创市场报告",
    en: "Zhejiang Science and Innovation Market Report",
    title: "烯牛数据：2025年一季度浙江省创投市场报告",
    desc: "2024年至2025年第一季度，浙江省创投市场活跃度与全国同步降低。浙江省重点发力医疗领域，创新药与医疗器械生产成为最热门赛道，同时人形机器人赛道融资增长显著。基金托管机构以地区银行与大型股份制银行为主。从城市角度来看，各市差距较大，湖州与嘉兴近年有明显发展。"
  },
  {
    tags: "2025年第一季度",
    type: "area",
    name: "北京科创市场报告",
    en: "Beijing Science and Innovation Market Report",
    title: "烯牛数据：2025年一季度北京科创市场报告",
    desc: "2024年至2025年第一季度，北京创投市场规模收缩，但仍与上海领跑全国。北京重点发力人工智能领域，人工智能产业融资数量逆市增长，AIGC、AI大模型成为最热门赛道，具身智能、人形机器人赛道融资翻倍增长。北京投资机构实力强劲，新增备案基金数量与规模均同比正向增长。"
  },
  {
    tags: "2025年第一季度",
    type: "area",
    name: "上海科创市场报告",
    en: "Shanghai Science and Innovation Market Report",
    title: "烯牛数据：2025年一季度上海科创市场报告",
    desc: "2024年至2025年第一季度，上海融资事件总数超越北京成为全国城市TOP1。先进制造、医疗、人工智能为上海重点融资领域，而消费领域融资事件占比自2021年开始回落。创新药赛道持续火热，具身智能、人形机器人赛道融资翻倍增长。但上海投资机构活跃情况不及北京，新增备案基金数量显著降低。"
  },
  {
    tags: "2024年度",
    type: "industry",
    name: "中国上市公司对外投资版图解析（2024）",
    en: "",
    title: "中国上市公司对外投资版图解析（2024）",
    desc: "2024年上市公司投资事件占比降至10.1%，战略投资占比提升至33.7%。上市公司对外投资呈现“直投+LP出资”双轮驱动模式，投资重心转向先进制造和人工智能领域。报告分析了上市公司对外投资三种典型模式及案例。报告还分析了10家重点上市公司的投资策略和10家明星创业公司背后的上市公司力量。"
  },
  {
    tags: "2025年度",
    type: "industry",
    name: "DeepSeek重构下AI创业与投资机会（2025）",
    en: "",
    title: "DeepSeek重构下AI创业与投资机会（2025）",
    desc: "2025年，人工智能成为创投市场唯一正增长行业，资本热点从大模型转向垂直行业应用，如AI+先进制造、AI+医疗等。重点赛道包括人形机器人、AI药物研发和脑机接口。重点企业如傅利叶智能、英矽智能等获得巨额融资。超300家机构出手AI，奇绩创坛、高瓴创投等机构表现活跃。"
  },
  {
    tags: "2024年度",
    type: "year",
    name: "中国创投市场数据报告",
    en: "CHINA VENTURE CAPITAL MARKET DATA REPORT",
    title: "烯牛数据：2024年中国创投市场数据报告",
    desc: "2024年中国创投市场融资数量与金额均创10年新低，市场整体收缩，热门赛道如人工智能、先进制造等仍受关注。上海超越北京成为融资事件最多城市。退出方面，并购事件回暖，IPO数量减少，但部分投资机构仍实现正增长。"
  },
  {
    tags: "2024年上半年",
    type: "area",
    name: "北京科创市场报告",
    en: "Beijing Science and Innovation Market Report",
    title: "烯牛数据：2024年上半年北京科创市场报告",
    desc: "2024年上半年，北京科创投融资市场活动稳健，融资数量和金额虽处于历史低位，但人工智能和先进制造领域的初创公司继续吸引大量资金。市场重点产业包括先进制造、企业服务、医疗和人工智能。"
  },
  {
    tags: "2024年度",
    type: "area",
    name: "上海科创市场报告",
    en: "Shanghai Science and Innovation Market Report",
    title: "烯牛数据：2024年上海科创市场报告",
    desc: "2024年，上海科创投融资市场活动呈现新动态，融资数量和金额有所调整。新能源汽车、芯片和大模型等赛道成为投资热点。市场重点产业包括先进制造、医疗、企业服务和新能源。"
  },
  {
    tags: "2023年度",
    type: "area",
    name: "安徽省私募科创数据分析",
    en: "Analysis of Private Equity Science and Innovation Data in Anhui",
    title: "烯牛数据：2023年安徽省私募科创数据分析",
    desc: "2023年安徽省私募科创投融资市场表现稳健，融资金额同比增长55.8%，融资事件数小幅减少。先进制造、医疗和人工智能领域成为投资热点，合肥市融资活跃度位列全国前十。"
  },
  {
    tags: "2025年2月",
    type: "month",
    name: "科创金融数据观察",
    en: "Finance Data Watch on Tech Innovation",
    title: "烯牛数据：科创金融数据观察2025年2月",
    desc: "2025年2月，国内投融资事件共626起，融资金额168亿元，因假期数量处于近半年低点。AIGC、具身智能赛道融资频繁且金额较高。安徽省创谷资本等国资机构表现活跃。LP方面，KKR备案了3.6亿元股权投资基金。IPO审核方面，沪深北交易所2月零受理，终止数降至近半年最低水平，影石创新注册生效。"
  },
  {
    tags: "2025年1月",
    type: "month",
    name: "科创金融数据观察",
    en: "Finance Data Watch on Tech Innovation",
    title: "烯牛数据：科创金融数据观察2025年1月",
    desc: "2025年1月，国内投融资事件共875起，融资金额376亿元，融资数量因假期减少但仍高于10月和11月。AIGC、具身智能、智能医疗赛道融资火热。山东省、南京市、合肥市地方国资出手活跃。LP方面，国家大基金三期投资的两支基金完成备案，总出资额达1640亿元。IPO审核方面，沪深交易所零受理，终止数上升至近6个月最高水平。"
  },
  {
    tags: "2024年12月",
    type: "month",
    name: "科创金融数据观察",
    en: "Finance Data Watch on Tech Innovation",
    title: "烯牛数据：科创金融数据观察2024年12月",
    desc: "2024年12月，国内投融资市场活跃，共披露1099起投融资事件，融资金额715亿元，环比增长显著。早期项目融资事件数环比增长69.23%，人工智能领域早期融资事件激增166.67%。AIGC赛道融资数量最多。基金备案方面，12月备案基金数量环比激增88.14%，浙江省备案基金数和金额均领先。IPO审核方面，12月38家企业获受理，北交所审核提速，整体IPO审核状态良好。"
  },
  {
    tags: "2023年度",
    type: "year",
    name: "中国创投市场数据报告",
    en: "China Venture Capital Market Data Report",
    title: "烯牛数据：2023年中国创投市场数据报告",
    desc: "2023年，中国创投市场整体保持审慎，融资事件和金额均创历史新低。市场对先进制造、医疗与新能源行业的投资热情持续，IPO活动虽有所放缓，但上市企业获得的VC/PE支持保持稳定。"
  },
  {
    tags: "2023年上半年",
    type: "year",
    name: "中国创投市场数据报告",
    en: "China Venture Capital Market Data Report",
    title: "烯牛数据：2023年上半年中国创投市场数据报告",
    desc: "2023年上半年，中国创投市场继续经历转型，融资事件和金额达到近年低点。早期融资活动遭遇瓶颈，而人工智能领域初创企业保持稳定。苏州和上海在融资数量和金额上表现突出。"
  },
  {
    tags: "2022年度",
    type: "year",
    name: "中国创投市场数据报告",
    en: "China Venture Capital Market Data Report",
    title: "烯牛数据：2022年中国创投市场数据报告",
    desc: "2022年，中国创投市场面临挑战，融资活动和资金规模呈现市场筛选和集中趋势。美元融资占比下降，人民币融资成为主导。市场关注点转向实体经济，二线城市在创投市场中的重要性日益凸显。"
  }]

export default function Research() {
  const { showModal } = useModal();

  return (
    <>
      <section className={styles.head} />
      {/*@ts-ignore*/}
      <div className={styles.list}>
        {list.map((r, i) => <div className={styles.card} key={"research"+i}>
          <div>
            <div className={styles.img} style={{background: `url("./static-official/images/xiniu-research-${r.type}.png")`}}>
              <div className={styles.tags} style={{color: TYPE_MAP[r.type]?.color}}>{r.tags}</div><div className={styles.tags} style={{color: TYPE_MAP[r.type]?.color}}>{TYPE_MAP[r.type]?.name}</div>
              <p className={styles.name}>{r.name}</p>
              {r.en?
                <p className={styles.en}>{r.en}</p>
                :
                null
              }
            </div>
            <h3>{r.title}</h3>
            <p className={styles.desc}>{r.desc}</p>
          </div>
          <Button withArrow type="link" width="85px"  onClick={() => showModal()}>立即获取&nbsp;</Button>
        </div>)}
      </div>
    </>
  )
}
